import { render, staticRenderFns } from "./PluginSetting.vue?vue&type=template&id=10efc0d9&scoped=true&"
import script from "./PluginSetting.vue?vue&type=script&lang=js&"
export * from "./PluginSetting.vue?vue&type=script&lang=js&"
import style0 from "./PluginSetting.vue?vue&type=style&index=0&id=10efc0d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10efc0d9",
  null
  
)

export default component.exports